import { BRIDGE_PAGE_CATEGORIES } from './bridgePageCategories';

export { BRIDGE_PAGE_CATEGORIES };
